import React from 'react';

import { LottieAnimation } from 'components/animation';

import animation from './json/index.plk.json';

export const OrderConfirmation = ({ isPaused = false }) => (
  <LottieAnimation options={{ animationData: animation }} isPaused={isPaused} />
);
